import React from "react";
import { Modal } from "react-bootstrap";
import styles from "../../_css/DeleteUserModal.module.css";
import {
  CustomButtonDanger,
  CustomButtonOutlineLight,
} from "../UI/CustomButtons";
import { useSelector } from "react-redux";
import { DELETE_USER_MODAL_DATA } from "../../data/uiComponents";

const DeleteUserModal = ({ show, onHide, onEndSession, title, btnText, cancelText }) => {

  const lang = useSelector((state) => state.language.lang);
  return (
    <>
      {/* Custom backdrop above everything */}
      {show && (
        <div 
          className={styles.customBackdrop}
          onClick={onHide}
        />
      )}
      <Modal
        show={show}
        onHide={onHide}
        centered
        className={styles.endSessionModal}
        style={{ zIndex: 3000 }}
        backdrop={false}
      >
      <Modal.Header className={" p-3 py-2"} closeButton>
        <Modal.Title
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "var(--color-1)",
          }}
        >
          {DELETE_USER_MODAL_DATA[lang].title}
   
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className={styles.iconSection}>
          <div className={styles.iconCircle}>
            <i>
              <img
                width={60}
                src={`${process.env.REACT_APP_PROJECT_URL}/img/question-mark.png`}
                alt="question-mark"
              />
            </i>
          </div>
          <div className={styles.title}>{title}</div>
        </div>
        <div
          className={
            styles.buttonRow + " d-flex justify-content-center gap-3 mt-4"
          }
        >
          <CustomButtonOutlineLight
            text={cancelText}
            onClick={onHide}
            width="100%"
          />
          <CustomButtonDanger text={btnText} onClick={onEndSession} width="100%" />
        </div>
      </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteUserModal;
